import keys from 'lodash/keys';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Text } from "~/native-ui/Typography";
//import get from 'lodash/get';
//import cn from 'classnames';
//import css from './css.css';

let propTypes = {
    href: PropTypes.string,
};
let ownPropNames = keys(propTypes);

export class LinkToSpan extends Component {
	static propTypes = propTypes;

    ownProps = () => {
        return omit(this.props,ownPropNames);
    };

	render() {
		return (
			<Text fontSize="inherit" lineHeight="inherit" {...this.ownProps()}>{this.props.children}</Text>
		);
	}
}